import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  FormGroup,
  ModalHeader
} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CustomSelect from "../../../../components/Common/CustomSelect";

const ModalMediaBuyerPlan = props => {

  let state = {
    isFormSubmit: false
  };

  const getMediaBuyers = item => {
    let media = [];
    item.mediaBuyers.map(i => {
      media.push({ label: i.number, value: i.id });
    });
    return media;
  };

  const onSubmitForm = (e, errors, params) => {
    state = { isFormSubmit: true };
    if (errors?.length === 0) {
      let data = {
        offer: props.offerId,
        mediaBuyer: params.mediaBuyer.value,
        planned_sum: params.planned_sum
      };
      props.addMediaBuyerPlan(data);
      return props.toggle();
    }
  };

  return (
    <Modal isOpen={props.isOpen} autoFocus={true} centered={true} toggle={props.toggle}>
      <ModalHeader tag="h4">Add media buyer plan</ModalHeader>
      {props.data !== null && (
        <ModalBody>
          <AvForm className="needs-validation" onSubmit={onSubmitForm}>
            <Row form>
              <Col className="col-12">
                <div className="mb-3">
                  <Label htmlFor="offer">Media buyer</Label>
                  <FormGroup>
                    <CustomSelect
                      name="mediaBuyer"
                      options={getMediaBuyers(props.data)}
                      placeholder="Select media buyer..."
                      classNamePrefix="select2-selection"
                      errorMessage="Media buyer field is required"
                      isFormSubmit={state.isFormSubmit}
											required
										/>
                  </FormGroup>
                </div>
                <div className="mb-3">
                  <AvField
                    name="planned_sum"
                    label="Planned sum"
                    type="number"
                    errorMessage="Invalid sum"
                    validate={{
                      required: { value: true },
                      minLength: { value: 1, errorMessage: "Min 1 number" }
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button type="submit" className="btn btn-success save-user">
                    Save changes
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      )}
    </Modal>
  );
};

ModalMediaBuyerPlan.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  currentMedia: PropTypes.object.isRequired,
  addMediaBuyerPlan: PropTypes.func.isRequired,
  offerId: PropTypes.number.isRequired
};

export default ModalMediaBuyerPlan;
